import { useQuery } from '@tanstack/react-query'

import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getPatientAttributes } from '../../apis/patientAttributes'
import type { PatientAttributesResponse } from '../../types'

// 患者の属性. 開いたときに 1 回取れば足りる (指導前準備の 2 秒ごとの GET には混ぜない.
// yakureki-back log/262 work-log/08 §3.4). polling しない・focus で取り直さない.
// enabled は呼び出し側が「監査の面を開いたか」で渡す.
export const usePatientAttributesQuery = (
  yakurekiId: string | undefined,
  enabled: boolean
) => {
  return useQuery<PatientAttributesResponse>({
    queryKey: queryKeys.patientAttributes.byEvent(yakurekiId ?? ''),
    queryFn: async () => {
      const response = await getPatientAttributes(yakurekiId as string)
      return response.data
    },
    enabled: enabled && !!yakurekiId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })
}
